import axiosInstance from "../axiosInstance";
import apiClient from "./axiosInstanceInspector";

// export const fetchUsers = () => {
//   return axiosInstance.get('/users');
// };

export const getAllCofRequests = async (officerId) => {
  return await apiClient.get(`/cofRequests`);
};
export const getAllPendingCofs = async () => {
  return await apiClient.get("/cofRequests1/pending");
};



export const getInspectors = async () => {
  return await apiClient.get("/inspector");
};

export const getInspectorById = async (id) => {
  return await apiClient.get(`/inspector/${id}`);
};


